var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['demo__color--' + _vm.color],style:({
    ..._vm.typography,
  })},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }